// Action Types
const TOGGLE_ADDRESS = "TOGGLE_ADDRESS";

const initialState: any = {
  show_addresses: false,
};

// Reducer
export function showUserAddresses(
  state = initialState,
  action: { type: any; payload: any }
) {
  switch (action.type) {
    case TOGGLE_ADDRESS:
      return {
        ...state,
        show_addresses: !state.show_addresses,
      };

    default:
      return state;
  }
}

// Action Creators
export function toggleShowAddresses() {
  return { type: TOGGLE_ADDRESS };
}
